import ufeApi from 'services/api/ufeApi';
// &env=ufe-dev

export function getContent({ path, language, country }) {
    const url = `/api/content${path}?ch=web&loc=${language}-${country}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: { 'x-requested-source': 'rwd' }
        })
        .then(data => data);
}

export default { getContent };
